import { render, staticRenderFns } from "./TransferRecord.vue?vue&type=template&id=20730b62&scoped=true"
import script from "./TransferRecord.vue?vue&type=script&lang=js"
export * from "./TransferRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20730b62",
  null
  
)

export default component.exports